export default __webpack_public_path__ + "static/agentic-ai-trasformazione-digitale-2025-6028541deb86f1162409f87c7f27ea06.png";